import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ChevronLeft, ChevronRight } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import css from './HorizontalSnapper.module.scss';
import scrollSnapper from '../ScrollSnapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isVertical = false;

var ChevronButton = function ChevronButton(_ref) {
  var disabled = _ref.disabled,
      left = _ref.left,
      iconOnly = _ref.iconOnly,
      onClick = _ref.onClick;
  var progression = left ? 'previous' : 'next';
  return /*#__PURE__*/_jsx("button", {
    "aria-label": "Scroll to ".concat(progression, " item"),
    className: cc([css.button, _defineProperty({}, css.buttonLeft, left), _defineProperty({}, css.hideBackground, iconOnly), _defineProperty({}, css.disabled, disabled), _defineProperty({}, css.hideIcon, disabled && iconOnly)]),
    disabled: disabled,
    onClick: disabled ? null : onClick,
    type: "button",
    children: left ? /*#__PURE__*/_jsx(ChevronLeft, {}) : /*#__PURE__*/_jsx(ChevronRight, {})
  });
};

ChevronButton.defaultProps = {
  iconOnly: false
};
ChevronButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  left: PropTypes.bool.isRequired,
  iconOnly: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

var HorizontalSnapper = function HorizontalSnapper(_ref6) {
  var addSpacing = _ref6.addSpacing,
      childClass = _ref6.childClass,
      className = _ref6.className,
      goTo = _ref6.goTo,
      iconOnlyButtons = _ref6.iconOnlyButtons,
      index = _ref6.index,
      parentClass = _ref6.parentClass,
      resetIndex = _ref6.resetIndex,
      scrollerRef = _ref6.scrollerRef,
      slides = _ref6.slides;
  var firstSrc = slides.length > 0 ? slides[0].src : '';
  useEffect(function () {
    resetIndex();
  }, [firstSrc, resetIndex, slides.length]);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, className]),
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.scroller, parentClass]),
      ref: scrollerRef // scrollable content needs to be focusable wihch allows left/right arrow navigation.
      ,
      tabIndex: 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      ,
      children: slides.map(function (_ref7) {
        var content = _ref7.content,
            id = _ref7.id;
        return /*#__PURE__*/_jsx("div", {
          className: cc([css.child, childClass, _defineProperty({}, css.spaced, addSpacing)]),
          children: content
        }, "snapper-child-".concat(id));
      })
    }), slides.length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChevronButton, {
        disabled: index <= 0,
        left: true,
        iconOnly: iconOnlyButtons,
        onClick: function onClick() {
          return goTo(index - 1);
        }
      }), /*#__PURE__*/_jsx(ChevronButton, {
        disabled: index >= slides.length - 1,
        left: false,
        iconOnly: iconOnlyButtons,
        onClick: function onClick() {
          return goTo(index + 1);
        }
      })]
    })]
  });
};

HorizontalSnapper.defaultProps = {
  addSpacing: false,
  className: '',
  iconOnlyButtons: false
};
HorizontalSnapper.propTypes = {
  addSpacing: PropTypes.bool,
  className: PropTypes.string,
  childClass: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  iconOnlyButtons: PropTypes.bool,
  index: PropTypes.number.isRequired,
  parentClass: PropTypes.string.isRequired,
  resetIndex: PropTypes.func.isRequired,
  scrollerRef: PropTypes.shape().isRequired,
  slides: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default scrollSnapper(HorizontalSnapper, isVertical);